import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  Input,
  OnChanges,
} from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { CommunityService } from "@app/core/services/community.service";
import { ResultStatus } from "@app/core/models/result-status";
import { ToastrService } from "ngx-toastr";
import * as _ from "lodash";

@Component({
  selector: "app-feeds-detail",
  templateUrl: "./feeds-detail.component.html",
  styleUrls: ["./feeds-detail.component.scss"],
})
export class FeedsDetailComponent implements OnInit, OnChanges {
  @Input() feedId: number;
  @Output() openCommunityMenu = new EventEmitter();
  @Input() filterValue = [];
  @Output() removeAppliedFilter = new EventEmitter();
  feedList = [];
  isDataLoaded = false;
  pageNo = 1;
  throttle = 300;
  scrollDistance = 2;
  scrollUpDistance = 2;
  feedLinks;

  constructor(
    private sanit: DomSanitizer,
    private communityService: CommunityService,
    private toaterService: ToastrService
  ) { }

  ngOnInit() {
  }

  ngOnChanges() {
    this.isDataLoaded = false;
    this.pageNo = 1;
    this.feedList = [];
    this.getFeedList();
  }

  getFeedList() {
    this.communityService.getFeedsList(this.feedId, this.pageNo).subscribe(
      (result) => {
        this.isDataLoaded = true;
        if (result.Status === ResultStatus.Success) {
          this.addItems(result.Data);
        } else {
          this.toaterService.error("something went wrong");
        }
      },
      (error) => { this.isDataLoaded = true; }
    );
  }

  addItems(responseData) {
    responseData.forEach((element) => {
      this.feedList.push(element);
    });
  }

  onScrollDown() {
    this.pageNo++;
    this.getFeedList();
  }
  onScrollUp() {
  }

  getSafeHtml(content) {
    return this.sanit.bypassSecurityTrustHtml(content);
  }

  getImgsSanitized(imageURL: any) {
    if (imageURL) {
      return this.sanit.bypassSecurityTrustUrl(imageURL);
    } else {
      return this.sanit.bypassSecurityTrustUrl("./assets/images/no-image-found.png");
    }
  }

  showCommunityMobileMenu() {
    this.openCommunityMenu.emit();
  }

  redirectToFeed(redirectUrl) {
    window.open(redirectUrl, "_blank");
  }

  removeFilter(filterItem) {
    this.removeAppliedFilter.emit(filterItem);
  }

  getMetadata(feed) {
    if (feed.MetaUrl || feed.MetaImage || feed.MetaTitle || feed.MetaDescription) {
      return [{ Url: feed.MetaUrl, Image: feed.MetaImage, Title: feed.MetaTitle, Description: feed.MetaDescription }];
    }
    return [];
  }
}
